import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export type ReferralTier = "bronze" | "silver" | "gold";

export interface ReferralRow {
  id: string;
  status: string;
  reward_points: number | null;
  signed_up_at: string;
  [k: string]: any;
}

export interface ReferralsState {
  code: string;
  tier: ReferralTier;
  count: number;
  earned: number;
  list: ReferralRow[];
  loading: boolean;
}

export function useReferrals(userId: string | null | undefined): ReferralsState {
  const [code, setCode] = useState("");
  const [tier, setTier] = useState<ReferralTier>("bronze");
  const [count, setCount] = useState(0);
  const [earned, setEarned] = useState(0);
  const [list, setList] = useState<ReferralRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      const [{ data: codeRow }, { data: profile }, { data: refs }] = await Promise.all([
        supabase.from("referral_codes").select("code").eq("user_id", userId).maybeSingle(),
        supabase.from("profiles").select("referral_tier").eq("user_id", userId).maybeSingle(),
        supabase
          .from("referrals")
          .select("*")
          .eq("referrer_id", userId)
          .order("signed_up_at", { ascending: false }),
      ]);
      if (cancelled) return;
      if (codeRow?.code) setCode(codeRow.code);
      if (profile?.referral_tier) setTier(profile.referral_tier as ReferralTier);
      if (refs) {
        setList(refs as ReferralRow[]);
        setCount(refs.filter((r: any) => r.status === "completed").length);
        setEarned(refs.reduce((s: number, r: any) => s + (r.reward_points || 0), 0));
      }
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { code, tier, count, earned, list, loading };
}